module.exports = __webpack_public_path__ + "media/FaktSoftPro-SemiBold_fb9fc9.woff";